import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { getGroupsByCompanyId } from "../getCompanies";
import { queryKeys } from "../queryKeys";

export default function useGroups() {
  const { companyId } = useParams();
  const queryClient = useQueryClient();
  const query = useQuery({
    queryKey: queryKeys.groupsByCompanyId(companyId!),
    queryFn: () => getGroupsByCompanyId(companyId),
  });

  return {
    ...query,
    invalidate: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.groupsByCompanyId(companyId!),
      });
      queryClient.invalidateQueries({
        queryKey: queryKeys.users(companyId!),
      });
    },
  };
}
